import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function Footer() {
  const quickLinks = [
    { id: 'footer_home', label: 'Home', href: '/homepage' },
    { id: 'footer_about', label: 'About', href: '/about' },
    { id: 'footer_courses', label: 'Courses', href: '/courses' },
    { id: 'footer_contact', label: 'Contact', href: '/contact' },
  ];

  const socialLinks = [
    { id: 'social_instagram', name: 'Instagram', icon: 'instagram', href: 'https://www.instagram.com/apollobitsacademy/' },
    { id: 'social_facebook', name: 'Facebook', icon: 'facebook', href: 'https://www.facebook.com/apollobitsacademy' },
    { id: 'social_pinterest', name: 'Pinterest', icon: 'pinterest', href: 'https://www.pinterest.com/apollobitsa/' },
    { id: 'social_linkedin', name: 'LinkedIn', icon: 'linkedin', href: 'https://linkedin.com/company/apollobits-academy/' },
  ];

  return (
    <footer className="bg-secondary text-secondary-foreground pt-20 pb-8 px-6 border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* About Section */}
          <div className="lg:col-span-2">
            <h3 className="font-display text-3xl uppercase tracking-tighter mb-4">
              Apollobits Academy
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed mb-6">
              Established in 2020, Apollobits Academy is a leading skill development institute focused on providing practical and technical training for students and professionals. We bridge the gap between education and industry.
            </p>
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.id}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary hover:scale-110 transition-all"
                  aria-label={social.name}
                >
                  <Icon name={`${social.icon}Icon` as any} size={20} className="text-white" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest mb-4 text-white">
              Quick Links
            </h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <Link
                    href={link.href}
                    className="text-sm text-muted-foreground hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest mb-4 text-white">
              Contact
            </h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li className="flex items-start gap-2">
                <Icon name="MapPinIcon" size={18} className="mt-0.5 flex-shrink-0" />
                <span>Shop No.1 and 2, Atlas Tower, Near Post Office, Station Road, Ulhasnagar 421003</span>
              </li>
              <li className="flex items-center gap-2">
                <Icon name="PhoneIcon" size={18} className="flex-shrink-0" />
                <div className="flex flex-col">
                  <a href="tel:9763150150" className="hover:text-white transition-colors">
                    9763150150
                  </a>
                  <a href="tel:9022227227" className="hover:text-white transition-colors">
                    9022227227
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-2">
                <Icon name="EnvelopeIcon" size={18} className="flex-shrink-0" />
                <a
                  href="mailto:contact@apollobits.in"
                  className="hover:text-white transition-colors"
                >
                  contact@apollobits.in
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground">
          <p>© 2025 Apollobits Academy. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link href="/privacy-policy" className="hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <span className="w-px h-3 bg-white/20"></span>
            <Link href="#" className="hover:text-white transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}